let es = {
    name: "Español",
    tag: 'es',
    values: {

    }
}

export default es